/* eslint-disable new-cap */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
import { Environment } from 'ha/config';
import { isBrowser } from 'ha/helpers/isBrowser';
import { DomainData, OneTrustCategoryIds, OneTrustOptions } from './types';
import { PAGES_WITHOUT_OVERLAY, TEST } from './constants';

declare global {
  var OneTrust:
    | undefined
    | {
        IsAlertBoxClosed: () => boolean;
        GetDomainData: () => DomainData;
        ToggleInfoDisplay: () => void;
      };
  var OnetrustActiveGroups: undefined | string;
  var OptanonWrapper: undefined | (() => void);
}

export const oneTrustDomainKey = ({ env, key }: OneTrustOptions) => {
  switch (env) {
    case Environment.PRODUCTION:
    case Environment.STAGE:
      return key;

    default:
      return key.includes(TEST) ? key : `${key}${TEST}`;
  }
};

export const oneTrustClassName = (
  ...categoryIds: OneTrustCategoryIds[]
): string => `optanon-category-${categoryIds.join('-')}`;

export const isBannerClosed = () => {
  if (!isBrowser()) {
    return undefined;
  }

  const isCookieBannerClosed = document.cookie.match(/OptanonAlertBoxClosed/g);

  return Boolean(isCookieBannerClosed);
};

export const getActiveCategories = (): OneTrustCategoryIds[] => {
  if (!window?.OnetrustActiveGroups) {
    return [];
  }

  return window.OnetrustActiveGroups.split(',').filter(
    Boolean,
  ) as OneTrustCategoryIds[];
};

export const runForNotRequiredCategories = (callback: () => void) => {
  if (getActiveCategories().length > 1) {
    // init analytics only if one of not required categoties is enabled
    callback();
  }
};

export const isPageWithOverlay = (pathname: string) =>
  !PAGES_WITHOUT_OVERLAY.some(path => pathname.includes(path));

export const showCookieSettings = () => {
  if (window?.OneTrust?.ToggleInfoDisplay) {
    window.OneTrust.ToggleInfoDisplay();
  }
};

const preventBodyScrolling = () => {
  // fix issue for background scrolling with the opened banner
  if (isPageWithOverlay(window.location.pathname)) {
    document.body.style.overflow = 'hidden';
  }
};

const allowBodyScrolling = () => {
  document.body.style.overflow = 'unset';
};

export const init = (callback: () => void) => {
  console.log('OneTrust init was called');

  if (!isBrowser()) {
    return;
  }

  if (!callback) {
    console.log("Callback function doesn't exist");
    return;
  }

  if (!isBannerClosed()) {
    // first loading
    preventBodyScrolling();

    window.OptanonWrapper = () => {
      console.log('Optanon called');
      runForNotRequiredCategories(callback);

      if (window.OneTrust?.IsAlertBoxClosed()) {
        allowBodyScrolling();
      }
    };
  } else {
    runForNotRequiredCategories(callback);
  }
};
